export const EvaluationTrainingColdGravity = {
    path: '/evaluation_training_cold_gravities',
    name: 'evaluation_training_cold_gravities',
    component: () => import('@/views/Evaluation/Gravity/EvaluationTrainingColdGravityPage.vue'),
    props: {
        type: 'EVALUATION_TRAINING_COLD',
    },
    children: [
        {
            path: '/evaluation_training_cold_gravities/add',
            name: 'evaluation_training_cold_gravities.add',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
        {
            path: '/evaluation_training_cold_gravities/edit/:id',
            name: 'evaluation_training_cold_gravities.edit',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
        {
            path: '/evaluation_training_cold_gravities/delete/:id',
            name: 'evaluation_training_cold_gravities.delete',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
        {
            path: '/evaluation_training_cold_gravities/view/:id',
            name: 'evaluation_training_cold_gravities.view',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
    ]
}